module.exports = __webpack_public_path__ + "static/media/julien-bourdette.ca054b21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/julien-bourdette.jpg
// module id = 1821
// module chunks = 0